import type { ButtonProps } from '@mui/material';

import { Button } from '@mui/material';

import { BRAND_COLOR } from 'src/theme/core';

export const BrandButton = (props: ButtonProps) => {
  const { variant, sx, ...other } = props;

  const containedVariant = variant === 'contained';

  if (containedVariant) {
    return (
      <Button
        variant={variant}
        {...other}
        sx={(theme) => ({
          background: BRAND_COLOR,
          backgroundColor: theme.palette.grey[700],
          color: `${theme.palette.common.white} !important`,
          ...{ sx },
        })}
      />
    );
  }

  return <Button variant={variant} {...other} />;
};
